module.exports = __webpack_public_path__ + "static/media/3.09e1fa6f.jpg";